import { OFFieldApi } from '../../generated/api/oFFieldApi.js';
import { OFPageType } from '../../generated/api/oFPageType.js';
import { OFQuestionType } from '../../generated/api/oFQuestionType.js';
import type { OpenFormChoice } from '../../generated/api/openFormChoice.js';
import type { OpenFormQuestion } from '../../generated/api/openFormQuestion.js';
import type { OpenFormSection } from '../../generated/api/openFormSection.js';

import './OpenForm.scss';

type Match = {
  (...values: OFPageType[]): (target?: OpenFormSection) => boolean;
  (...values: OFQuestionType[]): (target?: OpenFormQuestion) => boolean;
  (...values: OFFieldApi[]): (target?: OpenFormQuestion) => boolean;
  (...values: string[]): (target?: OpenFormSection | OpenFormQuestion | OpenFormChoice) => boolean;
};

const match =
  (target: OpenFormSection | OpenFormQuestion | OpenFormChoice) =>
  (value: OFPageType | OFQuestionType | OFFieldApi | string) => {
    switch (true) {
      case value in OFPageType:
        return value === (target as OpenFormSection).pageType;
      case value in OFQuestionType:
        return value === (target as OpenFormQuestion).type;
      case value in OFFieldApi:
        return value === (target as OpenFormQuestion).fieldApiName;
      case /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value):
        return value === target.guid;
      default:
        return false;
    }
  };

export const any: Match = (...values) =>
  !values.length ? _ => false : target => (!target?.guid ? false : values.some(match(target)));

export const has: Match = (...values) =>
  !values.length ? _ => false : target => (!target?.guid ? false : values.every(match(target)));

export const not: Match = (...values) =>
  !values.length ? _ => false : target => (!target?.guid ? false : !values.some(match(target)));
